import { createContext, useContext } from "react";
import { useMyInfoQuery } from "@newHooks/query/myInfo/myInfo.query";
import { UserWithInfo } from "@maven-rest/sso/User.dto";

type MyInfoContextType = {
  myInfo?: UserWithInfo;
};

const MyInfoContext = createContext<MyInfoContextType>({
  myInfo: undefined,
});

function useMyInfoContext() {
  return useContext(MyInfoContext);
}

function MyInfoProvider({ children }: { children: React.ReactNode }) {
  const { data: myInfo } = useMyInfoQuery();

  return <MyInfoContext.Provider value={{ myInfo }}>{children}</MyInfoContext.Provider>;
}

export { MyInfoContext, useMyInfoContext, MyInfoProvider };
